import { Injectable, OnDestroy } from "@angular/core";
import { FuseNavigation } from "@fuse/types";
import { SubscriptionService } from "app/core/service/subscription.service";
import { SubscriptionDTO } from "app/data/schema/Subscription/SubscriptionDTO";
import { ApiDashboardService } from "app/data/service/api-dashboard.service";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Injectable({
    providedIn: "root"
})
export class NavigationService implements OnDestroy {
    subscription: SubscriptionDTO;

    private _adminNavigation: FuseNavigation[] = [
        {
            id: "home",
            title: "Home",
            translate: "NAV.HOME",
            type: "item",
            icon: "home",
            roles: ["Admin", "AppManager", "SuperAdmin", "Analytics"],
            url: "/home",
            adminVersion: 2
        },
        {
            id: "app",
            title: "App",
            translate: "NAV.APP",
            type: "item",
            icon: "settings_cell",
            roles: ["Admin", "AppManager", "SuperAdmin", "Analytics"],
            function: (): void => {
                window.location.href = this.appUrl;
            },
            adminVersion: 1
        },
        {
            id: "RelatorioGraficos",
            title: "Relatório e Gráficos",
            translate: "NAV.RelatorioGraficos",
            type: "collapsable",
            icon: "insert_chart",
            roles: ["Admin", "SuperAdmin", "Analytics"],
            children: [
                {
                    id: "analytics",
                    title: "Analytics",
                    translate: "NAV.ANALYTICS",
                    type: "item",
                    icon: "bar_chart",
                    url: "/EAD/analytics",
                    adminVersion: 1
                },
                {
                    id: "upload-file",
                    title: "Importação de dados",
                    translate: "NAV.UPLOAD_FILE",
                    type: "item",
                    icon: "bar_chart",
                    url: "/analytic/upload-file",
                    adminVersion: 2
                }
            ],
            adminVersion: 2
        },
        {
            id: "Cadastros",
            title: "Cadastros",
            translate: "NAV.CADASTROS",
            type: "collapsable",
            icon: "playlist_add",
            roles: ["Admin", "AppManager", "SuperAdmin"],
            defaultOpen: true,
            children: [
                {
                    id: "Users",
                    title: "Usuários",
                    translate: "NAV.USERS",
                    type: "item",
                    icon: "person",
                    url: "/permissoes/usuarios",
                    adminVersion: 1
                },
                {
                    id: "Invites",
                    title: "Convites",
                    translate: "NAV.INVITES",
                    type: "item",
                    icon: "contact_mail",
                    url: "/registrations/invites",
                    adminVersion: 2
                },
                {
                    id: "calendar",
                    title: "Calendários",
                    translate: "NAV.CALENDARS",
                    type: "item",
                    icon: "business",
                    roles: ["SuperAdmin"],
                    url: "/registrations/calendar",
                    adminVersion: 2
                },
                {
                    id: "bulk-course-subscription",
                    title: "Inscrições de cursos em massa",
                    translate: "NAV.BULK_COURSE_SUBSCRIPTION",
                    type: "item",
                    icon: "supervisor_account",
                    url: "/registrations/bulk-course-subscription",
                    adminVersion: 2
                },
                {
                    id: "UsersGroups",
                    title: "Grupos",
                    translate: "NAV.GROUPS",
                    type: "item",
                    icon: "group_work",
                    url: "/registrations/grupos",
                    adminVersion: 1
                },
                {
                    id: "Categories",
                    title: "Categorias",
                    translate: "NAV.CATEGORIES",
                    type: "item",
                    icon: "category",
                    url: "/registrations/categories",
                    adminVersion: 1
                },
                {
                    id: "Courses",
                    title: "Cursos",
                    translate: "NAV.COURSES",
                    type: "item",
                    icon: "play_circle_outlined",
                    url: "/registrations/courses",
                    adminVersion: 1
                },
                {
                    id: "subplatform",
                    title: "Sub Plataforma",
                    translate: "NAV.SUBPLATFORM",
                    type: "item",
                    icon: "library_books",
                    roles: ["Admin", "SuperAdmin"],
                    feature: "subPlatform",
                    url: "/registrations/subplatform",
                    adminVersion: 2
                }
            ],
            adminVersion: 1
        },
        {
            id: "gamification",
            title: "Gamificação",
            type: "collapsable",
            icon: "videogame_asset",
            roles: ["Admin", "SuperAdmin"],
            translate: "NAV.GAMIFICATION.TITLE",
            feature: "gamification",
            children: [
                {
                    id: "leaderboard",
                    title: "Classificação",
                    translate: "NAV.GAMIFICATION.LEADERBOARDS",
                    type: "item",
                    icon: "format_list_numbered",
                    url: "/gamification/leaderboards",
                    adminVersion: 1
                },
                {
                    id: "gamification_report",
                    title: "Relatórios",
                    translate: "NAV.GAMIFICATION.REPORT",
                    type: "item",
                    icon: "insert_drive_file",
                    url: "/gamification/report",
                    adminVersion: 1
                },

                {
                    id: "gamificationConfig",
                    title: "Configurações",
                    type: "collapsable",
                    icon: "settings",
                    children: [
                        {
                            id: "achievements",
                            title: "Conquistas",
                            translate: "NAV.GAMIFICATION.ACHIEVEMENTS",
                            type: "item",
                            icon: "star",
                            url: "/gamification/achievements",
                            adminVersion: 1
                        },
                        {
                            id: "ranking",
                            title: "Ranking",
                            translate: "NAV.GAMIFICATION.RANKINGS",
                            type: "item",
                            icon: "ballot",
                            url: "/gamification/rankings",
                            adminVersion: 1
                        },

                        {
                            id: "details",
                            title: "Pontuações",
                            translate: "NAV.GAMIFICATION.DETAILS",
                            type: "item",
                            icon: "score",
                            url: "/gamification/details",
                            adminVersion: 1
                        }
                    ],
                    adminVersion: 1
                }
            ],
            adminVersion: 1
        },
        {
            id: "downloads",
            title: "Downloads",
            type: "collapsable",
            icon: "cloud_download",
            roles: ["Admin", "SuperAdmin"],
            feature: "downloads",
            translate: "NAV.DOWNLOADS",
            children: [
                {
                    id: "certificates",
                    title: "Certificados",
                    translate: "NAV.CERTIFICATES",
                    type: "item",
                    icon: "keyboard_tab",
                    url: "/downloads/certificates",
                    adminVersion: 2
                }
            ],
            adminVersion: 2
        },
        {
            id: "storage",
            title: "Storage",
            type: "collapsable",
            icon: "storage",
            roles: ["Admin", "SuperAdmin"],
            feature: "storage",
            translate: "NAV.STORAGE.TITLE",
            children: [
                {
                    id: "storage_report",
                    title: "Relatório Simples",
                    translate: "NAV.STORAGE.REPORT",
                    type: "item",
                    icon: "insert_drive_file",
                    url: "/storage/report",
                    adminVersion: 1
                }
            ],
            adminVersion: 1
        },
        {
            id: "payments",
            title: "Pagamentos",
            translate: "NAV.PAYMENTS",
            type: "collapsable",
            icon: "payments",
            roles: ["Admin", "SuperAdmin"],
            feature: "precification",
            children: [
                {
                    id: "Plans",
                    title: "Planos",
                    translate: "NAV.PLANS",
                    type: "item",
                    icon: "list_alt",
                    url: "/pagamentos/plans",
                    adminVersion: 1
                },
                {
                    id: "BILLING_ACCOUNTS",
                    title: "Contas",
                    translate: "NAV.BILLING_ACCOUNTS",
                    type: "item",
                    icon: "money",
                    url: "/payments/accounts",
                    adminVersion: 2
                },
                {
                    id: "splitRule",
                    title: "Divisão de pagamento",
                    translate: "NAV.SPLITRULE",
                    type: "item",
                    icon: "call_split",
                    url: "/payments/split-rules",
                    adminVersion: 2
                },
                {
                    id: "coupon",
                    title: "Cupons",
                    type: "collapsable",
                    icon: "card_giftcard",
                    children: [
                        {
                            id: "coupon",
                            title: "Cupons",
                            translate: "NAV.COUPONS",
                            type: "item",
                            icon: "list",
                            url: "/payments/coupons",
                            adminVersion: 2
                        },
                        {
                            id: "couponSalesHistory",
                            title: "Histórico de vendas",
                            translate: "NAV.COUPONS_SALES_HISTORY",
                            type: "item",
                            icon: "history",
                            url: "/pagamentos/coupons/sales-history",
                            adminVersion: 1
                        }
                    ],
                    adminVersion: 1
                },
                // {
                //     id: "iugu",
                //     title: "Iugu",
                //     type: "collapsable",
                //     icon: "attach_money",
                //     children: [
                //         {
                //             id: "iugu_reports",
                //             title: "Relatório",
                //             translate: "NAV.IUGU.REPORT",
                //             type: "item",
                //             icon: "insert_drive_file",
                //             url: "/pagamentos/iugu/report",
                //             adminVersion: 1
                //         }
                //     ],
                //     adminVersion: 1
                // }
            ],
            adminVersion: 1
        },

        {
            id: "Fiscal",
            title: "Fiscal",
            translate: "NAV.FISCAL",
            type: "collapsable",
            icon: "insert_drive_file",
            roles: ["Admin", "SuperAdmin"],
            children: [
                // desabilitado temporariamente até atualização para Ui2 com os novos campos de cfg para NFSeN
                // {
                //     id: "invoice-gateways",
                //     title: "Gateways",
                //     translate: "NAV.INVOICE_GATEWAYS",
                //     type: "item",
                //     icon: "meeting_room",
                //     url: "/fiscal/gateways",
                //     adminVersion: 1
                // },
                {
                    id: "invoice-report",
                    title: "Notas",
                    translate: "NAV.INVOICE_REPORT",
                    type: "item",
                    icon: "list",
                    url: "/fiscal/invoice-report",
                    adminVersion: 1
                }
            ],
            adminVersion: 1
        },
        {
            id: "Configuracoes",
            title: "Configurações",
            translate: "NAV.CONFIGURATIONS",
            type: "collapsable",
            icon: "settings",
            roles: ["Admin", "SuperAdmin"],
            children: [
                {
                    id: "subscription-user-fields",
                    title: "Dados adicionais (Usuários)",
                    translate: "NAV.SUBSCRIPTION_USER_FIELDS",
                    type: "item",
                    icon: "edit",
                    url: "/configuracoes/subscription-user-fields",
                    adminVersion: 1
                },
                {
                    id: "platformcustomization",
                    title: "Personalização da plataforma",
                    translate: "NAV.PLATFORM_CUSTOMIZATION",
                    type: "collapsable",
                    icon: "image",
                    children: [
                        {
                            id: "host-change",
                            title: "Host",
                            translate: "NAV.HOST_CONFIG",
                            type: "item",
                            icon: "language",
                            url: "/settings/host-change",
                            adminVersion: 2
                        },
                        {
                            id: "subscription-courses-catalog",
                            title: "Catálogo de Cursos",
                            translate: "NAV.SUBSCRIPTION_COURSES_CATALOG",
                            type: "item",
                            icon: "burst_mode",
                            url: "/configuracoes/subscription-courses-catalog",
                            adminVersion: 1
                        },
                        {
                            id: "subscription-courses-catalog-old",
                            title: "Catálogo de Cursos (Old)",
                            translate: "NAV.SUBSCRIPTION_COURSES_CATALOG_OLD",
                            type: "item",
                            icon: "burst_mode",
                            url: "/configuracoes/subscription-courses-catalog-old",
                            adminVersion: 1
                        },
                        {
                            id: "subscription-certification",
                            title: "Certificado",
                            translate: "NAV.SUBSCRIPTION_CERTIFICATION",
                            type: "item",
                            icon: "image",
                            url: "/settings/certificates",
                            adminVersion: 2
                        },
                        {
                            id: "Templates",
                            title: "Templates",
                            translate: "NAV.TEMPLATES",
                            type: "item",
                            icon: "mail",
                            url: "/configuracoes/templates",
                            adminVersion: 1
                        },
                        {
                            id: "subscription-theme",
                            title: "tema",
                            translate: "NAV.SUBSCRIPTION_THEME",
                            type: "item",
                            icon: "color_lens",
                            url: "/settings/theme",
                            adminVersion: 2
                        },
                        {
                            id: "subscription-footer",
                            title: "Rodapé",
                            translate: "NAV.SUBSCRIPTION_FOOTER",
                            type: "item",
                            icon: "settings_applications",
                            url: "/settings/footer",
                            adminVersion: 2
                        }
                    ],
                    adminVersion: 2
                },

                {
                    id: "data-analysis-settings",
                    title: "Ferramentas Analytics",
                    translate: "NAV.DATA_ANALYSIS_SETTINGS",
                    type: "item",
                    icon: "insert_chart",
                    url: "/configuracoes/data-analysis-settings",
                    adminVersion: 1
                },
                {
                    id: "subscription-login-settings",
                    title: "Tela de login",
                    translate: "NAV.SUBSCRIPTION_LOGIN_SETTINGS",
                    type: "item",
                    icon: "input",
                    url: "/configuracoes/subscription-login-settings",
                    adminVersion: 1
                },
                {
                    id: "PoliciesAndTerms",
                    title: "Políticas e termos",
                    translate: "NAV.POLICIES_TERMS",
                    type: "collapsable",
                    icon: "security",
                    children: [
                        {
                            id: "subscription-privacy-policy",
                            title: "Política de privacidade",
                            translate: "NAV.SUBSCRIPTION_PRIVACY_POLICY",
                            type: "item",
                            icon: "security",
                            url: "/settings/policies/privacy-policy",
                            adminVersion: 2
                        },
                        {
                            id: "subscription-terms-of-use",
                            title: "Termos de uso",
                            translate: "NAV.SUBSCRIPTION_TEMRS_OF_USE",
                            type: "item",
                            icon: "security",
                            url: "/settings/policies/terms-of-use",
                            adminVersion: 2
                        },
                        {
                            id: "subscription-terms-of-purchase",
                            title: "Termos de compra",
                            translate: "NAV.SUBSCRIPTION_TERMS_OF_PURCHASE",
                            type: "item",
                            icon: "security",
                            url: "/settings/policies/terms-of-purchase",
                            adminVersion: 2
                        }
                    ],
                    adminVersion: 2
                }
            ],
            adminVersion: 1
        },
        {
            id: "Webhooks",
            title: "Webhooks",
            type: "collapsable",
            icon: "wifi_tethering",
            roles: ["SuperAdmin", "Admin"],
            children: [
                {
                    id: "Webhooks",
                    title: "Configurações",
                    translate: "NAV.WEBHOOKS_CONFIGS",
                    type: "item",
                    icon: "link",
                    roles: ["SuperAdmin", "Admin"],
                    url: "/webhooks/configurations",
                    adminVersion: 1
                },
                {
                    id: "webhooksEvents",
                    title: "Eventos",
                    translate: "NAV.WEBHOOKS_EVENTS",
                    type: "item",
                    icon: "mail",
                    roles: ["SuperAdmin"],
                    url: "/webhooks/events",
                    adminVersion: 1
                }
            ],
            adminVersion: 1
        },
        {
            id: "CompanyInformation",
            title: "Informações da empresa",
            translate: "NAV.COMPANY_INFORMATION",
            type: "collapsable",
            icon: "business",
            roles: ["SuperAdmin"],
            children: [
                {
                    id: "subscription-data",
                    title: "Dados",
                    translate: "NAV.SUBSCRIPTION_DATA",
                    type: "item",
                    icon: "business_center",
                    url: "/settings/subscription-data",
                    adminVersion: 2
                },
                {
                    id: "support-contacts",
                    title: "Contatos para suporte",
                    translate: "NAV.SUPPORT_CONTACTS",
                    type: "item",
                    icon: "contact_phone",
                    url: "/configuracoes/support-contacts",
                    adminVersion: 2
                },
                {
                    id: "subscription-contract",
                    title: "Contrato",
                    translate: "NAV.SUBSCRIPTION_CONTRACT",
                    type: "item",
                    icon: "description",
                    url: "/settings/subscription-contract",
                    adminVersion: 2
                }
            ],
            adminVersion: 2
        },
        {
            id: "superAdmin",
            title: "Super Admin",
            translate: "NAV.CADASTROS_SUPER_ADMIN",
            type: "collapsable",
            icon: "apps",
            roles: ["SuperAdmin"],
            children: [
                {
                    id: "subscriptions",
                    title: "Assinaturas",
                    translate: "NAV.SUBSCRIPTIONS",
                    type: "item",
                    icon: "business",
                    roles: ["SuperAdmin"],
                    url: "/super-admin/subscriptions",
                    adminVersion: 2
                }
            ],
            adminVersion: 2
        }
    ];

    // Private
    private _unsubscribeAll: Subject<any>;
    private appUrl: string;

    constructor(private _subscriptionService: SubscriptionService, private apiDashboardService: ApiDashboardService) {
        this._unsubscribeAll = new Subject();

        _subscriptionService
            .currentSubscriptionAsync()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((s) => {
                this.subscription = s;
                if (s?.host) this.appUrl = `https://${s.host}/app/home`;
            });
    }

    private getDefault(roles = []): Observable<FuseNavigation[]> {
        return new Observable<FuseNavigation[]>((observable) => {
            roles = roles || [];

            let nav = this._adminNavigation;
            nav.forEach((itemMenu) => {
                nav = this.checkItemsVisibility(nav, itemMenu, roles);
            });

            const RelatorioGraficos = nav.filter((a) => a.id == "RelatorioGraficos")[0];
            this.apiDashboardService.GetList().subscribe((a) => {
                a.forEach((element) => {
                    if (element.id == "home" || RelatorioGraficos?.children.find((x) => x.id == `REL_${element.id}`))
                        return;

                    RelatorioGraficos?.children.push({
                        id: `REL_${element.id}`,
                        title: element.caption,
                        //translate: "NAV.PLANS",
                        type: "item",
                        icon: element.icon ?? "list_alt",
                        url: `/relatorios/${element.id}`,
                        adminVersion: 2
                    });
                });

                observable.next(nav);
                observable.complete();
            });
        });
    }

    checkItemsVisibility(nav: FuseNavigation[], itemMenu: FuseNavigation, roles: string[]): FuseNavigation[] {
        if (itemMenu.roles?.length > 0) {
            let hasRole = false;

            for (let index = 0; index < roles.length; index++) {
                const userRole = roles[index];

                if (itemMenu.roles?.includes(userRole)) {
                    hasRole = true;
                    break;
                }
            }

            if (!hasRole) nav = nav.filter((obj) => obj.id !== itemMenu.id);
        }

        switch (itemMenu.feature) {
            case "gamification":
                if (!this.subscription?.features?.gamification?.active)
                    nav = nav.filter((obj) => obj.id != itemMenu.id);
                break;
            case "storage":
                if (!this.subscription?.features?.storage?.active) nav = nav.filter((obj) => obj.id != itemMenu.id);
                break;
            case "checkout":
                if (!this.subscription?.features?.checkout?.active) nav = nav.filter((obj) => obj.id != itemMenu.id);
                break;
            case "precification":
                if (this.subscription?.features?.noPricing?.active) nav = nav.filter((obj) => obj.id != itemMenu.id);
                break;
            case "subPlatform":
                if (!this.subscription?.features?.subPlatform?.active) nav = nav.filter((obj) => obj.id != itemMenu.id);
                break;
            default:
                break;
        }

        itemMenu?.children?.forEach((subItem) => {
            itemMenu.children = this.checkItemsVisibility(itemMenu.children, subItem, roles);
        });

        return nav;
    }

    public getNavigationByLoggedUser = (roles = []): Observable<FuseNavigation[]> => {
        return this.getDefault(roles);
    };

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
